export default /^[1-9]\d{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
